import { Box, IconButton, Tooltip, Typography } from '@mui/material'
import NotesIcon from '@mui/icons-material/Notes'
import TextFieldsIcon from '@mui/icons-material/TextFields'
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
import { FS_SM, ICON_SM, ICON_XS } from '../common/theme'
import { structureToPlainText } from './TaResponse'
import type { TextStructure } from '../types/textstructure'
import iconAutoFix from '../img/autofixhigh.png'


interface TaWordCountProps {
  // Provide one of `text` or `structure`. `structure` is the new
  // canonical answer shape - when passed, the plain text is derived via
  // `structureToPlainText` and counted the same way. `text` is kept for
  // callers that already hold a flat string (HTML or plain).
  text?: string
  structure?: TextStructure
  question?: any
  replylimit?: any
  referral?: string
  onWizardOpen?: (referral: string | undefined, question: any) => void
}

export default function TaWordCount({
  text,
  structure,
  question,
  replylimit,
  referral,
  onWizardOpen,
}: TaWordCountProps) {
  const effectiveText = text ?? (structure ? structureToPlainText(structure) : '')
  const count = effectiveText
    ? effectiveText.replace(/<[^>]+>/g, ' ').trim().split(/\s+/).filter(Boolean).length
    : 0

  const isCharCount = replylimit?.charcount
  const limit = replylimit?.answerlimit ?? 0
  const isOverLimit = count > limit && limit > 0
  const noWordWizard = question?.nowordwizard

  if (count === 0) return null

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
      <Tooltip title={isCharCount ? 'Char Count' : 'Word Count'}>
        <Box
          sx={{
            display: 'flex', alignItems: 'center', gap: 0.25,
            color: isOverLimit ? 'error.main' : 'inherit',
          }}
        >
          {isCharCount
            ? <TextFieldsIcon sx={{ fontSize: ICON_SM }} />
            : <NotesIcon sx={{ fontSize: ICON_SM }} />}
          <Typography
            variant="caption"
            sx={{ fontSize: FS_SM, fontWeight: isOverLimit ? 700 : 400 }}
          >
            {count}
          </Typography>
        </Box>
      </Tooltip>

      {!noWordWizard && isOverLimit && onWizardOpen && (
        <Tooltip title="Reduce Word Count">
          <span>
            <IconButton
              size="small"
              sx={{ p: 0.25, color: 'error.main' }}
              onClick={() => onWizardOpen(referral, question)}
            >
              <img src={iconAutoFix} alt="Score & Fix" style={{ width: ICON_XS, height: ICON_XS }} />
              {/* <AutoFixHighIcon sx={{ fontSize: ICON_SM }} /> */}
            </IconButton>
          </span>
        </Tooltip>
      )}
    </Box>
  )
}

